import type { MqttConnectionStatus } from "../types/telemetry";

interface ConnectionBannerProps {
  connectionStatus: MqttConnectionStatus;
  telemetryStale: boolean;
}

/**
 * Full-width takeover shown on the kiosk when the numbers on screen can no
 * longer be trusted. A 6px status dot is invisible from the pit wall; this is
 * not.
 */
export function ConnectionBanner({ connectionStatus, telemetryStale }: ConnectionBannerProps) {
  let tone: "error" | "warning" | null = null;
  let title = "";
  let detail = "";

  if (connectionStatus === "error" || connectionStatus === "disconnected") {
    tone = "error";
    title = "TELEMETRY LINK DOWN";
    detail = "Not connected to the MQTT broker — values below are frozen";
  } else if (connectionStatus === "connecting") {
    tone = "warning";
    title = "CONNECTING…";
    detail = "Waiting for the MQTT broker";
  } else if (telemetryStale) {
    tone = "warning";
    title = "DATA STALE";
    detail = "Connected, but the car has not published telemetry recently";
  }

  if (!tone) return null;

  return (
    <div className={`connection-banner connection-banner--${tone}`} role="alert" aria-live="assertive">
      <span className="connection-banner__title">{title}</span>
      <span className="connection-banner__detail">{detail}</span>
    </div>
  );
}
